export const SENTRY_TAG = {
  TYPE: 'type',
};

export const SENTRY_ERROR_TYPE = {
  PAID_SIGNUP_FAILED: 'paid-signup-failed',
  FREE_SIGNUP_FAILED: 'free-signup-failed',
  FREE_TRIAL_SIGNUP_FAILED: 'freetrial-signup-failed',
  PAYMENT_FAILED: 'payment-failed',
  AS_SIGNUP_FAILED: 'as-signup-failed',
  SECURE_3D_FAILED: '3d-secure-failed',
  HOSTED_FIELD_ERROR: 'hosted-field-error',
};
